import { Box } from "@mui/material";
import "./ConfigurationDrawer.scss";
import { TextInput, Typography } from "@chr/eds-react";
import { ConfigurationDrawerTitleProps } from "./ConfigurationDrawerProps";
import { useTranslation } from "@chr/online-shared-ui-localizations";

export const ConfigurationDrawerTitle = ({
  widgetTitle,
  setWidgetTitle
}: ConfigurationDrawerTitleProps) => {
  const translate = useTranslation();
  
  return (
      <Box className="configuration-title">
        <Typography variant="subtitle100" fontWeight="semiBold">
          {translate('Widget name')}
        </Typography>
        <TextInput
          id="configuration-title"
          data-testid="configuration-title"
          fullWidth
          inputType="text"
          label=""
          aria-label={widgetTitle}
          value={widgetTitle}
          onChange={(event) => {
            setWidgetTitle(event?.currentTarget?.value);
          }}
        />
      </Box>
  );
}

export default ConfigurationDrawerTitle;